import React, { createContext, useContext } from 'react';

const AppConfigContext = createContext(null);

export function AppConfigProvider({ children, config }) {
  return (
    <AppConfigContext.Provider value={config}>
      {children}
    </AppConfigContext.Provider>
  );
}

export function useAppConfig() {
  return useContext(AppConfigContext);
}
